import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalizedCountryNames} from 'i18n-iso-countries';
import {AppConfigService} from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  countries: any;

  constructor(private translateService: TranslateService) {
    // @ts-ignore
    this.countries = require('i18n-iso-countries');
    if (AppConfigService.settings) {
      this.registerCountriesLocales(AppConfigService.settings.localization.supportedLanguages);
    }
  }

  registerCountriesLocales(locales: string[]) {
    for (const locale of locales) {
      // @ts-ignore
      this.countries.registerLocale(require('i18n-iso-countries/langs/' + locale + '.json'));
    }
  }

  getCountries(lang?: string): string[] {
    lang = lang || this.translateService.currentLang || AppConfigService.settings.localization.supportedLanguages[0];
    const countriesList = this.getCountiresList(lang);
    return Object.keys(countriesList).map(key => countriesList[key]).sort((a, b) => a.localeCompare(b, lang));
  }

  getCountiresList(lang?: string): LocalizedCountryNames {
    return this.countries.getNames(lang || this.translateService.currentLang || AppConfigService.settings.localization.supportedLanguages[0]);
  }

  getAlpha2Code(name: string, lang?: string) {
    return this.countries.getAlpha2Code(name, lang || this.translateService.currentLang || AppConfigService.settings.localization.supportedLanguages[0]);
  }

  getName(code: string, lang?: string) {
    return this.countries.getName(code, lang || this.translateService.currentLang || AppConfigService.settings.localization.supportedLanguages[0]);
  }

}
